declare const __PROJECT_NAME__: string | undefined;

const log = (...args: any) => {
  if (window.DH_DEBUG !== true) return;

  // Safe when __PROJECT_NAME__ wasn't injected by DefinePlugin (e.g. wrong build)
  const projectName =
    typeof __PROJECT_NAME__ !== 'undefined' ? __PROJECT_NAME__ : 'unknown';

  // eslint-disable-next-line no-console
  console.log(
    `%c[BNDL - ${projectName}]`,
    `color: #00A3C3; font-weight: bold;`,
    ...args,
  );
};

export default log;
